import { useEffect, useState } from 'react';
import {
  adminApiStats,
  adminCampaignCall,
  authForAdmin,
} from '../../api/admin';

export const Operations = () => {
  const [userValidated, setUserValidated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [manualCalls, setManualCalls] = useState(0);
  const [manualCallsFailed, setManualCallsFailed] = useState(0);
  const [apiStats, setApiStats] = useState({});

  useEffect(() => {
    const validateUser = async () => {
      try {
        const isValid = await authForAdmin();
        setUserValidated(isValid);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    validateUser();
  }, []);

  const handleManualCall = async () => {
    try {
      const result = await adminCampaignCall();
      if (result) {
        setManualCalls((prev) => prev + 1);
      } else {
        setManualCallsFailed((prev) => prev + 1);
      }
    } catch (error) {
      console.log('Error making manual call:', error);
    }
  };

  const getApiStats = async () => {
    try {
      const stats = await adminApiStats();
      setApiStats(stats);
      console.log(stats);
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!userValidated) {
    return <div>Not authorized</div>;
  }

  if (userValidated) {
    return (
      <>
        <div className="text-green-400">Authorized</div>
        <br />
        <p
          className="text-gray-100 text-4xl font-extrabold uppercase tracking
              transform rotate-2  
              shadow-xl animate-pulse"
        >
          SHhhhhHHHHHhhh Top secret
        </p>
        <img src="https://media.tenor.com/S2QvGasXcugAAAAM/shhhh-cat-sigma.gif" />
        <p className="my-2">
          ***Dont spam*** the call button it actually makes a call please wait 5
          seconds before pressing again
        </p>

        <p className="my-2">
          The manual calls are stored locally so it will reset to 0 if u refresh
        </p>

        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          onClick={() => handleManualCall()}
        >
          Call Campaign
        </button>
        <p className="text-green">Manual calls succesful: {manualCalls}</p>
        <p className="text-red">Manual calls failed {manualCallsFailed}</p>

        <h1 className="text-4xl my-2">Current API Stats:</h1>
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          onClick={() => getApiStats()}
        >
          Get Marketing Api Stats
        </button>
        {JSON.stringify(apiStats, null, 2)}
      </>
    );
  }
};
